import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const MenuControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;

	const emptymenu={
		menu_icon: "",
		menu_name: "",
		// menu_type: "",
		menu_position: "",
		menu_link: ""
	}

	const [user, setUser] = useState({
		menu_icon: "",
		menu_name: "",
		// menu_type: "",
		menu_position: "",
		menu_link: ""
	})


	const history = useHistory();
	const [data, setData] = useState([]);
	const [dataval, setdataval] = useState([]);
	const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1, setStyle1] = useState(false);
	const [menu_type,setMenutype]=useState("");

	const clearInput = () => {
		setSearchTerm("");
	  };
	
	const handelInput = (event) => {
		event.preventDefault();
		const { name, value } = event.target;
		console.log(name, value)
		setUser({ ...user, [name]: value });

		
	}


	const handelMenutype = (event) => {

		setMenutype(event.target.value);

		// if (event.target.value === '1') {
		// 	setIsVisible(true);
		// } else {
		// 	setIsVisible(false);
		// }
	}



	const [searchTerm, setSearchTerm] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const indexOfLastItem = currentPage * itemsPerPage;
	const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	let filteredItems = data.filter((item) =>
		`${item.menu_name.toLowerCase()}${item.menu_type_name.toLowerCase()}`.includes(searchTerm.toLowerCase())

	);
	const filteredData = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
	const startIndex = (currentPage - 1) * itemsPerPage;

	useEffect(() => {
		setCurrentPage(1);
	}, [searchTerm]);

	const paginate = (pageNumber) => setCurrentPage(pageNumber);

	const handleSearch = (event) => {
		//console.log(event.target.value);
		setSearchTerm(event.target.value);
	};

	const handleRowsPerPageChange = (e) => {
		setItemsPerPage(Number(e.target.value));
		setCurrentPage(1); // Reset to first page
	};




	useEffect(() => {
		axios.get(API_BASE_URL + '/fetchmenu', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

			//.then(res =>console.log(res.data))
			.then(res => setData(res.data))
			.catch(err => console.log(err));
	}, [])


	useEffect(() => {
		axios.get(API_BASE_URL + '/fetchurl', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

			//.then(res =>console.log(res.data))
			.then(res => setUrlRes(res.data))
			.catch(err => console.log(err));
	}, [])

	useEffect(() => {
		handleUpdate();
	}, []);





	const handleUpdate = async (id) => {

		axios.get(API_BASE_URL + '/showmenu/' + id, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
			.then(res1 => setUser(res1.data))
			.catch(err => console.log(err))
	};


	const handleSubmit = async (e) => {

		e.preventDefault();
		// setError(null);
		// setLoading(true);
		//  e.preventDefault();
		

		//console.log(user.menu_icon);
		axios.post(API_BASE_URL + '/addmenu', { menu_icon: user.menu_icon, menu_name: user.menu_name, menu_type: menu_type, menu_position: user.menu_position, menu_link: user.menu_link }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// 	console.log(response.data);
			// 	console.log(response.data.message);
			// })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};



			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	const handleEditSubmit = (e) => {

		// console.log('hi');


		e.preventDefault();

		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		console.log(user);

		axios.post(API_BASE_URL + '/updatemenu', { menu_icon: user.menu_icon, menu_name: user.menu_name, menu_type: user.menu_type, menu_position: user.menu_position, menu_link: user.menu_link, id: user.id }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// 	console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {

			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};


	// const [globalFilterText,setGlobalFilterText]=useState();

	// const handleGlobalFilter=(e)=>{

	// 	const value= e.target.value || '';
	// 	setGlobalFilterText(value);

	// };

	// const filteredData=data.filter((row)=>{
	// return Object.values(row).some((value)=> value.toString().toLowerCase().includes(globalFilterText.toLowerCase())
	// );
	// }); 




	return (
		<>
			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>


					<div className="section-body mt-3">
						<div className="container-fluid">
							<div className="row clearfix">
								<div className="col-md-12">
									<div className="card">
										<div className="card-header">
											<h3 className="card-title">Add Menu</h3>
										</div>
										<div className="card-body">
											<form onSubmit={handleSubmit}>

												<div class="row">

													<div className="col-md-2 col-sm-6">
														<div className="form-group">
														<label className="form-label">Menu Icon <span className="form-required">*</span></label>
															<input type="text" className="form-control" name="menu_icon" value={user.menu_icon}
																onChange={handelInput} placeholder="Menu Icon" />
														</div>
													</div>

													<div className="col-md-2 col-sm-6">
														<div className="form-group">
														<label className="form-label">Menu Name <span className="form-required">*</span></label>
															<input type="text" className="form-control" name="menu_name" value={user.menu_name}
																onChange={handelInput} placeholder="Menu Name" />
														</div>
													</div>

													<div className="col-md-2 col-sm-6">
														<div className="form-group">
														<label className="form-label">Position <span className="form-required">*</span></label>
															<input type="text" className="form-control" name="menu_position" value={user.menu_position}
																onChange={handelInput} placeholder="Position" />
														</div>
													</div>

													<div className="col-md-2 col-sm-6">
														<div className="form-group">
														<label className="form-label">Menu Type <span className="form-required">*</span></label>
															<select name="menu_type" id="menu_type"  className="form-control custom-select" value={menu_type} onChange={handelMenutype} style={{ "width": "130px" }}>
																<option value="">Menu Type</option>
																<option value={1}>Direct Menu</option>
																<option value={2}>Sub Menu</option>
															</select>
														</div>
													</div>



													<div className="col-md-2 col-sm-6">
														<div className="form-group"><br />
														<label className="form-label"><span className="form-required"></span></label>
															<button type="submit" className="btn btn-primary">
																Add Menu
															</button>

														</div>
													</div>

												</div>

												{menu_type==1 && (
													<div class="row">
														<div className="col-md-4 col-sm-6">
															<select name="menu_link" id="menu_link" className="form-control custom-select" value={user.menu_link} onChange={handelInput}>
																<option value="" disabled>Select Menu Link</option>
																<option></option>
																{urlres.map(option => (
																	<option key={option.id} value={option.id}>
																		{option.link}
																	</option>
																))}
															</select>
														</div>
													</div>
												)}









											</form>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>




					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">






										<div className="card-header">
											<h3 className="card-title" style={{ color: '#e96827' }}>Menu List</h3>
											<div className="card-options">
												<form>
													<div className="input-group">
														<select style={{
															padding: '8px',
															marginRight: '20px',
															borderRadius: '4px',
															border: '1px solid #ccc',
															backgroundColor: '#BCD1DB', display: 'flex', justifyContent: 'left'
														}}
															id="rowsPerPage"
															value={itemsPerPage}
															onChange={handleRowsPerPageChange}
														>
															<option value={10}>10</option>
															<option value={25}>25</option>
															<option value={50}>50</option>
															<option value={100}>100</option>
														</select>

														<div style={{ position: "relative", width: "300px" }}>

													<input
															type="text"
															className="form-control form-control-sm"
															placeholder="Search"
															value={searchTerm}
															onChange={handleSearch} 
															style={{
																width: "100%",
																padding: "10px",
																paddingRight: "30px", // Extra space for the clear icon
																boxSizing: "border-box",
															  }} 
														/>


{searchTerm.length>0 && ( 
        <span
          onClick={clearInput}
          style={{
            position: "absolute",
			top: "50%",
			right:"10px",
			transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#aaa",
            fontSize: "18px",
			// marginLeft: '260px !important',
            
          }}
        >
          ✖
        </span>
       )}
													</div>
													</div>
												</form>
											</div>
										</div>

										{/* <div>
											<DataTable 
											columns={column} 
											data={data}
											customStyles={customStyles}
											pagination 
											highlightOnHover
											responsive
											paginationPerPage={10}
											paginationRowsPerPageOptions={[25,50,100,500]}
											className="table table-striped table-bordered"> 
										</DataTable>
										</div> */}



										<div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
															<th>S.No</th>
															<th>Menu Name</th>
															<th>Menu Type</th>
															<th>Action</th>
														</tr>
													</thead>
													<tbody>
														{
															filteredData.map((menu, index) => {



																return <tr key={index}>
																	<td className="d-flex">
																		<span style={menu.menu_type == '1' ? { "color": "green" } : { "color": "red" }}
																			className="avatar avatar-blue"
																			data-toggle="tooltip"
																			data-original-title="Avatar Name"
																		>
																			{index + 1}
																		</span>

																	</td>
																	<td>
																		<span>{menu.menu_name}</span>
																	</td>


																	<td>
																		<span>{menu.menu_type_name}</span>
																	</td>





																	<td>



																		<button
																			type="button" onClick={() =>{ handleUpdate(menu.id);setUser(emptymenu)}}
																			className="btn btn-icon btn-sm"
																			title="Edit" data-toggle="modal"
																			data-target="#exampleEditModal"
																		>
																			<i className="fa fa-edit" />
																		</button>




																		<Link to={`/hr-submenu?id=${menu.id}`}>
																			{menu.menu_type == '2' ? <i className="fa fa-eye" /> : ''}
																		</Link>


																	</td>
																</tr>
															})
														}

													</tbody>
												</table>
											</div>

											<nav aria-label="Page navigation">
												<ul className="pagination mb-0 justify-content-end">
													<li className="page-item"><button className="page-link"
														key={'f'}
														onClick={() => paginate(1)}
													>
														First
													</button></li>

													{Array.from(
														{ length: Math.ceil(filteredItems.length / itemsPerPage) },
														(_, index) => (
															<li className="page-item">
																<button className="page-link"
																	key={index + 1}
																	onClick={() => paginate(index + 1)}
																>
																	{index + 1}
																</button></li>
														)
													)}

													<li className="page-item">
														<button className="page-link"
															key={'l'}
															onClick={() => paginate(Math.ceil(filteredItems.length / itemsPerPage))}
														>
															Last
														</button></li>

												</ul>
											</nav>


										</div>
									</div>
								</div>


							</div>
						</div>
					</div>

				</div>
			</div>


			<div
				className="modal fade"
				id="exampleEditModal"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true" 
				// onClick={() =>setUser(emptymenu)}
			>
				<form onSubmit={handleEditSubmit}>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLabel">
									Edit Menu
								</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="row clearfix">

									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Menu Icon <span className="form-required">*</span></label>
											<input type="text" className="form-control" name="menu_icon" value={user.menu_icon}
												onChange={handelInput} placeholder="Menu Icon" />

											<input name="menu_id" value={user.id} type="hidden" />

										</div>
									</div>

									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Menu Name <span className="form-required">*</span></label>
											<input type="text" className="form-control" name="menu_name" value={user.menu_name}
												onChange={handelInput} placeholder="Menu Name" />
										</div>
									</div>

									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Position <span className="form-required">*</span></label>
											<input type="text" className="form-control" name="menu_position" value={user.menu_position}
												onChange={handelInput} placeholder="Position" />
										</div>
									</div>

									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Menu Type <span className="form-required">*</span></label>
											<select name="menu_type" id="menu_type" className="form-control custom-select" value={user.menu_type} onChange={handelInput} >
												<option value="" disabled>Menu Type</option>
												<option value={1}>Direct Menu</option>
												<option value={2}>Sub Menu</option>
											</select>
										</div>
									</div>


									{user.menu_type == 1 || isVisible ? (

										<div className="col-md-12 col-sm-12">
											<select name="menu_link" id="menu_link" className="form-control custom-select" value={user.menu_link} onChange={handelInput}>
												<option value="" disabled>Select Menu Link</option>
												<option></option>
												{urlres.map(option => (
													<option key={option.id} value={option.id}>
														{option.link}
													</option>
												))}
											</select>
										</div>

									) : null}

								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" onClick={() =>setUser(emptymenu)} data-dismiss="modal">
									Close
								</button>
								<button type="submit" className="btn btn-primary">
									Save changes
								</button>
							</div>
						</div>
					</div>

				</form>

			</div>








		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(MenuControl);